module.exports = __webpack_public_path__ + "img/search_domain.a1b99fd0.svg";